import type { CSSProperties, ReactNode } from 'react'

export function Modal({
  title,
  onClose,
  children,
  footer,
  width = 480,
}: {
  title: string
  onClose: () => void
  children: ReactNode
  footer?: ReactNode
  width?: number
}) {
  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 1000, padding: 16,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '100%', maxWidth: width,
          background: 'var(--bg-1)', border: '0.5px solid var(--bd-0)',
          borderRadius: 10, color: 'var(--t-0)',
          display: 'flex', flexDirection: 'column', maxHeight: '85vh',
        }}
      >
        <header style={{ padding: '12px 16px', borderBottom: '0.5px solid var(--bd-0)', display: 'flex', alignItems: 'center' }}>
          <div style={{ fontSize: 14, fontWeight: 600, flex: 1 }}>{title}</div>
          <button onClick={onClose} style={iconBtn} aria-label="Close">×</button>
        </header>
        <div style={{ padding: 16, overflow: 'auto', flex: 1 }}>{children}</div>
        {footer && (
          <footer style={{ padding: '10px 16px', borderTop: '0.5px solid var(--bd-0)', display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            {footer}
          </footer>
        )}
      </div>
    </div>
  )
}

export const inputStyle: CSSProperties = {
  width: '100%', padding: '8px 10px',
  background: 'var(--bg-2)', border: '0.5px solid var(--bd-0)',
  borderRadius: 6, color: 'var(--t-0)', fontSize: 13, outline: 'none',
  boxSizing: 'border-box', marginTop: 4,
}

export const labelStyle: CSSProperties = {
  display: 'block', fontSize: 11, color: 'var(--t-2)', marginTop: 10,
}

export const btnPrimary: CSSProperties = {
  padding: '7px 12px', background: 'var(--info)', color: '#fff', border: 'none', borderRadius: 6, fontSize: 12, cursor: 'pointer',
}
export const btnGhost: CSSProperties = {
  padding: '7px 12px', background: 'transparent', color: 'var(--t-1)', border: '0.5px solid var(--bd-0)', borderRadius: 6, fontSize: 12, cursor: 'pointer',
}
export const btnDanger: CSSProperties = {
  padding: '7px 12px', background: 'transparent', color: 'var(--crit)', border: '0.5px solid var(--crit-bd, rgba(255,107,107,0.35))', borderRadius: 6, fontSize: 12, cursor: 'pointer',
}

const iconBtn: CSSProperties = {
  background: 'transparent', color: 'var(--t-2)', border: 'none', fontSize: 18, cursor: 'pointer', lineHeight: 1,
}
